function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function cov_t8tym4m7f() {
  var path = "/app/src/utils/get-url-search-params.ts";
  var hash = "df698a65c2412cf4f2dfbfa588cdf4897b7c02c3";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/utils/get-url-search-params.ts",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 34
        },
        end: {
          line: 21,
          column: 1
        }
      },
      "1": {
        start: {
          line: 4,
          column: 20
        },
        end: {
          line: 4,
          column: 63
        }
      },
      "2": {
        start: {
          line: 6,
          column: 23
        },
        end: {
          line: 18,
          column: 3
        }
      },
      "3": {
        start: {
          line: 8,
          column: 32
        },
        end: {
          line: 8,
          column: 73
        }
      },
      "4": {
        start: {
          line: 10,
          column: 6
        },
        end: {
          line: 15,
          column: 14
        }
      },
      "5": {
        start: {
          line: 20,
          column: 2
        },
        end: {
          line: 20,
          column: 22
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 1,
            column: 34
          },
          end: {
            line: 1,
            column: 35
          }
        },
        loc: {
          start: {
            line: 3,
            column: 5
          },
          end: {
            line: 21,
            column: 1
          }
        },
        line: 3
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 7,
            column: 4
          },
          end: {
            line: 7,
            column: 5
          }
        },
        loc: {
          start: {
            line: 7,
            column: 43
          },
          end: {
            line: 16,
            column: 5
          }
        },
        line: 7
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 10,
            column: 13
          },
          end: {
            line: 15,
            column: 13
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 11,
            column: 10
          },
          end: {
            line: 14,
            column: 11
          }
        }, {
          start: {
            line: 15,
            column: 10
          },
          end: {
            line: 15,
            column: 13
          }
        }],
        line: 10
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {
      "0": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "df698a65c2412cf4f2dfbfa588cdf4897b7c02c3"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_t8tym4m7f = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_t8tym4m7f();
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
cov_t8tym4m7f().s[0]++;
export var getURLSearchParams = function getURLSearchParams(params) {
  cov_t8tym4m7f().f[0]++;
  var urlParams = (cov_t8tym4m7f().s[1]++, new URLSearchParams(window.location.search));
  var searchParams = (cov_t8tym4m7f().s[2]++, Object.entries(params).reduce(function (acc, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      propName = _ref2[0],
      urlParameterName = _ref2[1];
    cov_t8tym4m7f().f[1]++;
    var urlParameterValue = (cov_t8tym4m7f().s[3]++, urlParams.get(urlParameterName));
    cov_t8tym4m7f().s[4]++;
    return urlParameterValue ? (cov_t8tym4m7f().b[0][0]++, _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, propName, urlParameterValue))) : (cov_t8tym4m7f().b[0][1]++, acc);
  }, {}));
  cov_t8tym4m7f().s[5]++;
  return searchParams;
};